var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_3097",
    "data-name": "Gruppe 3097",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_profil_grey",
    transform: "translate(8.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3636",
    "data-name": "Pfad 3636",
    d: "M22.346,3.946c1.331,1.854,1.4,6.09,1.33,8.45a1.423,1.423,0,0,1-1.4,1.412H1.05a.859.859,0,0,1,0-1.718H21.965c.067-2.724-.164-5.957-1.015-7.143a9.139,9.139,0,0,0-3.894-3.075A6.52,6.52,0,0,1,11.539,5.2C9.525,5.2,7.714,4.034,6.39,1.9A8.069,8.069,0,0,0,2.564,5.074a12.812,12.812,0,0,0-.847,4.695.859.859,0,0,1-.859.851H.851A.859.859,0,0,1,0,9.753c0-.374.063-3.7,1.061-5.509A10.069,10.069,0,0,1,6.369.062,1,1,0,0,1,7.588.541C8.631,2.466,10,3.483,11.54,3.483A5.067,5.067,0,0,0,15.8.642c.041-.068.077-.126.106-.172A1.011,1.011,0,0,1,17.05.044a10.672,10.672,0,0,1,5.3,3.9Z",
    transform: "translate(0 12.974)",
    fill: "#238cb9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3637",
    "data-name": "Pfad 3637",
    d: "M4.167,13.093C4,13,0,10.866,0,7.037,0,1.843,3.6,0,6.684,0c2.92,0,6.331,1.75,6.331,6.684,0,5.055-6.373,8.391-6.644,8.53a.859.859,0,0,1-.786-1.527c.057-.03,5.713-3,5.713-7,0-1.165-.333-4.966-4.613-4.966-1.165,0-4.966.384-4.966,5.319,0,2.8,3.214,4.517,3.246,4.534a.859.859,0,0,1-.8,1.522Z",
    transform: "translate(5.119)",
    fill: "#238cb9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3638",
    "data-name": "Pfad 3638",
    d: "M2.538,4.062A3.273,3.273,0,0,0,.627,1.684.853.853,0,0,1,.031.631a.864.864,0,0,1,1.061-.6,4.919,4.919,0,0,1,3.1,3.56,13.582,13.582,0,0,1,.345,3.047.859.859,0,0,1-.859.859h0a.859.859,0,0,1-.859-.858,12.057,12.057,0,0,0-.279-2.575Z",
    transform: "translate(16.403 16.319)",
    fill: "#238cb9",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfil);
export default __webpack_public_path__ + "static/media/profil.d7c7a65a951b76e247ac3a9f418a6684.svg";
export { ForwardRef as ReactComponent };